import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { initMetaPixel, initGoogleAnalytics } from './utils/analytics';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
// Lazy-load below-fold components to reduce initial bundle size
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const CountdownTimer = lazy(() => import('./components/CountdownTimer').then(m => ({
  default: m.CountdownTimer
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const AulaListaSection = lazy(() => import('./components/AulaListaSection').then(m => ({
  default: m.AulaListaSection
})));
const ComparisonTableExtended = lazy(() => import('./components/ComparisonTableExtended').then(m => ({
  default: m.ComparisonTableExtended
})));
const TestimonialsPreGuarantee = lazy(() => import('./components/TestimonialsPreGuarantee').then(m => ({
  default: m.TestimonialsPreGuarantee
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
function LazyFallback() {
  return <div className="w-full py-12 flex items-center justify-center bg-brand-dark" data-id="element-0">
      <div className="w-8 h-8 border-2 border-brand-yellow border-t-transparent rounded-full animate-spin" data-id="element-1" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Add preconnect hints for critical origins to reduce network latency
    const origins = [{
      href: 'https://cdn.magicpatterns.com',
      crossorigin: false
    }, {
      href: 'https://fonts.googleapis.com',
      crossorigin: false
    }, {
      href: 'https://fonts.gstatic.com',
      crossorigin: true
    }];
    origins.forEach(({
      href,
      crossorigin
    }) => {
      if (!document.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        if (crossorigin) link.crossOrigin = '';
        document.head.appendChild(link);
      }
    });
    initMetaPixel('1272995411715259');
    initGoogleAnalytics('G-HSL0N5H37P');
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-yellow selection:text-black" data-id="element-2">
      {/* Above-the-fold: loaded eagerly */}
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />

      {/* Priority below-fold: testimonials + pricing CTA */}
      <Suspense fallback={<LazyFallback data-id="element-6" />} data-id="element-5">
        <Testimonials data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <TomosSection data-id="element-9" />
        <BonusSection data-id="element-10" />
        <CountdownTimer data-id="element-11" />
        <PricingSection data-id="element-12" />
      </Suspense>

      {/* Secondary content */}
      <Suspense fallback={<LazyFallback data-id="element-14" />} data-id="element-13">
        <AulaListaSection data-id="element-15" />
        <ComparisonTableExtended data-id="element-16" />
        <TestimonialsPreGuarantee data-id="element-17" />
        <Guarantee data-id="element-18" />
      </Suspense>

      {/* Tertiary content */}
      <Suspense fallback={<LazyFallback data-id="element-20" />} data-id="element-19">
        <FAQ data-id="element-21" />
        <ComparisonTable data-id="element-22" />
        <FinalCTA data-id="element-23" />
        <PurchasePopup data-id="element-24" />
      </Suspense>
    </div>;
}